<template>
    <div class="container home" ref="container">
        <div class="level-one-menu" :class="isShow==true?'level-one-menu1':(isShow1==true?'level-one-menu2':'level-one-menu')">
            <figure class="logo"><img src="../../assets/images/logo.png"></figure>
            <ul class="menu-list">
                <li class="menu-item" v-for="item in mainList" :key="item.id" :class="{active:levelOneCurrId == item.id}"
                    @click="selectMenu(item.id)" @dblclick="dbclick">
                    <p style="width: 40px; line-height: 48px;"><i class="icon" :class="'icon-' + item.url"></i></p>
                    <span style="width: 200px" class="text">{{item.describe}}</span>
                </li>
            </ul>
        </div>
        <div class="level-two-menu" v-if="isShowLevelTwo" ref="twoMenu" :style="roleId == 9 ? {width: '200px'} : {width: '130px'}">
            <span class="title" :class="{border:!typeArr.length}">{{levelTwoTitle}}</span>
            <ul class="menu-list" id="two-menu" v-if="typeArr.length">
                <li class='type-list' v-for="(type, index) in typeArr" :key='index'>
                    <span class='type-name'>{{type}}</span>
                    <ul>
                         <li class="menu-item" v-if="type==item.type" v-for="item in levelTwoMenu" :key='item.id' :class="{active:levelTwoCurrId == item.id}"
                            @click="selectMenu(item.id)" @dblclick="dbclick">{{item.describe}}</li>
                    </ul>
                </li>
            </ul>
            <ul class="menu-list" id="two-menu" v-else>
                <li class="menu-item" v-for="item in levelTwoMenu" :key='item.id' :class="{active:levelTwoCurrId == item.id}"
                    @click="selectMenu(item.id)" @dblclick="dbclick">{{item.describe}}</li>
            </ul>
        </div>
        <div class="level-three-menu" :class="{'left-distance200':isHasDistance,'left-distance100':!isHasDistance, 'left-distance180': isHasDistance && roleId != 9}">
            <div class="nav-bar">
                <!--<div class="title" v-if="!enterChildPage" v-for="item in levelThreeMenu" :key="item.id"
                    :class="{current:levelThreeCurrId == item.id}" @click="turnPage(item)">{{item.title}}</div>
                <div class="title" v-if="enterChildPage">
                    <span class="prev-title" @click="backPrev()">{{parentName}}</span> / <span>{{childrenName}}</span>
                </div>-->
                <div class="right-haddle"><!--
                    <p class="step" v-if="equal" @click="stepFun">新手指引</p>-->
                    <p class="iconfont icon-update" v-if="roleId == 1" @click="jumpFun(2)"></p>
                    <div class="icon-group">
                        <i class="icon icon-1" v-if="badge == 0"></i>
                        <el-badge :value="badge" class="home-item" v-else>
                            <el-popover placement="bottom-start" trigger="click">
                                <el-tabs class="home-tabs" v-model="activeNames" @tab-click="handleClicks">
                                    <el-tab-pane :label="'通知（' + badge1 + '）'" name="first">
                                        <div class="list">
                                            <div class="item" v-for="(item, index) in dataList1" :key="index" @click="noticeQyFun(item.m_type)">
                                                <div class="title" v-if="item.m_type == 0"><span class="iconfont icon-tzgg"></span>{{item.m_theme}}</div>
                                                <div class="title" v-else-if="item.m_type == 1"><span class="iconfont icon-flfg"></span>{{item.m_theme}}</div>
                                                <div class="text" v-html="item.m_content.length > 50 ? item.m_content.substring(0, 50) + '...' : item.m_content"></div>
                                                <div class="message">
                                                    <div class="time">{{item.send_time}}</div>
                                                    <div class="msg">{{item.NAME}}</div>
                                                </div>
                                            </div>
                                            <div class="btns" v-if="badge1 == 0">
                                                暂无通知
                                            </div>
                                        </div>
                                    </el-tab-pane>
                                    <el-tab-pane :label="'培训材料（' + badge3 + '）'" name="second">
                                        <div class="list">
                                            <div class="item" v-for="(item, index) in dataList2" :key="index" @click="noticeQyFun">
                                                <div class="title" v-if="item.m_type == 2 || item.m_type == 3 || item.m_type == 4 || item.m_type == 5"><span class="iconfont icon-pxcl"></span>{{item.m_theme}}</div>
                                                <div class="message">
                                                    <div class="time">{{item.send_time}}</div>
                                                    <div class="msg">{{item.NAME}}</div>
                                                </div>
                                            </div>
                                            <div class="btns" v-if="badge3 == 0">
                                                暂无培训材料
                                            </div>
                                        </div>
                                    </el-tab-pane>
                                    <el-tab-pane :label="'消息（' + badge4 + '）'" name="third">
                                        <div class="list">
                                            <div class="item" v-for="(item, index) in dataList3" :key="index" @click="noticeQyFun">
                                                <div class="title" v-if="item.ins_isok == 1"><span class="iconfont icon-hg"></span>本次餐饮服务日常检查结果合格！</div>
                                                <div class="title" v-else-if="item.ins_isok == 0"><span class="iconfont icon-bhg"></span>本次餐饮服务日常检查结果不合格，请企业及时进行自查！</div>
                                                <div class="message">
                                                    <div class="time">{{item.send_time}}</div>
                                                    <div class="msg">{{item.NAME}}</div>
                                                </div>
                                            </div>
                                            <div class="btns" v-if="badge4 == 0">
                                                暂无消息
                                            </div>
                                        </div>
                                    </el-tab-pane>
                                </el-tabs>
                                <!--<el-badge :value="badge1" class="item" v-if="badge1 != 0">
                                    <el-button type="text" size="small" @click="noticeQyFun(1)">通知公告</el-button>
                                </el-badge>
                                <br v-if="badge1 != 0"/>
                                <el-badge :value="badge2" class="item" v-if="badge2 != 0">
                                    <el-button type="text" size="small" @click="noticeQyFun(2)">法律法规</el-button>
                                </el-badge>
                                <br v-if="badge2 != 0"/>
                                <el-badge :value="badge3" class="item" v-if="badge3 != 0">
                                    <el-button type="text" size="small" @click="noticeQyFun(3)">培训材料</el-button>
                                </el-badge>
                                <br v-if="badge3 != 0"/>
                                <el-badge :value="badge4" class="item" v-if="badge4 != 0">
                                    <el-button type="text" size="small" @click="noticeQyFun(4)">我的消息</el-button>
                                </el-badge>-->
                                <i slot="reference" class="icon icon-1"></i>
                            </el-popover>
                        </el-badge>
                        <i class="icon icon-2" v-if="roleId != 126 && roleId != 113" @click="jumpFun"></i>
                    </div>
                    <div class='user' @click="userClick()">
                        <i class="icon icon-3"></i>
                        <span>{{loginName}}</span>
                        <div class="exit-btns">
                            <i v-if='isPaas && roleId == 1' class="exit" @click="jumpPageFun(1)">PAAS</i>
                            <i v-if='isCg && roleId == 9' class="exit" @click="jumpPageFun(2)">超管</i>
                            <i v-if='isExit' class="exit" @click="backLogin()">退出</i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <p class="node-tips" v-if="equal && yyzt == '2'"><span class="iconfont icon-time"></span>暂停营业中！</p>
        <div class="main"  :class="{'left-distance200':isHasDistance,'left-distance100':!isHasDistance, 'left-distance180': isHasDistance && roleId != 9}">
            <router-view/>
        </div>
    </div>
</template>
<script>
// import menu from "../../assets/test/menu.js";
// import Statistical from "../statistical/statistical";
// import StandingBook from "../standingBook/standingBook";
// import Order from '@/components/order/order'
// import Management from '@/components/management/management'
// import Goods from '@/components/goods/goods'
// import Settings from '@/components/settings/settings'
// import District from '@/components/district/district'
// import Farmwork from '@/components/farmwork/farmwork'
import {getDefaultProductTypes} from "../../js/goods/goods.js";
import {Loginout} from '../../js/login/ajax.js'
import {GetUnreadMessageCount} from '../../js/noticeQy/noticeQy.js'
import {login} from "../../js/login/ajax.js";
import {GetNodeJyzt} from '../../js/settings/settings.js'
export default {
    name:'name',
    data(){
        return{
            mainList:[],//主菜单列表
            levelTwoMenu:[],//二级菜单
            levelThreeMenu:[],//三级菜单

            levelTwoTitle:'',//二级菜单标题

            levelOneCurrId:'',//一级菜单选中项
            levelTwoCurrId:'',//二级菜单选中项
            levelThreeCurrId:'',//三级菜单选中项

            isShowLevelTwo:true,//二级菜单是否存在
            isHasDistance:true,//二级菜单的间距

            isExit:false,//退出
            enterChildPage:false,//内容部分进入子页
            parentName:'',//导航上级标题
            childrenName:'',//导航下级标题

            fromPrevPageMsg:"",//返回上级数据
            toPrevPageMsg:'',
            typeArr:[],//二级菜单分类
            loginName: '管理员',
            account: '',
            password: '',
            remember: '',
            roleId: '',
            userId: '',
            user:'',
            isShow : false,
            isShow1:false,
            account2: '',
            password2: '',
            badge: 0,
            badge1: 0,
            badge2: 0,
            badge3: 0,
            badge4: 0,
            node_id: '',
            isPaas: false,
            isCg: false,
            equal: false, // 配餐企业、单位食堂、学校食堂餐饮企业信息，根据roleId判断
            activeNames: 'first',
            dataList1: [],
            dataList2: [],
            dataList3: [],
            yyzt: null,
            form: {
                dataTime: [],
                startTime: '',
                endTime: '',
            },
            click_time: null, // 单击双击事件
        }
    },
    created() {
        this.loginName =  localStorage.getItem('loginName');
        let localAccount = localStorage.getItem('account');
        let localPassword = localStorage.getItem('password');
        if(localAccount.indexOf('cryptographic+') != -1){
            let atob1 = localAccount.substr(14);
            let atob2 = localPassword.substr(14);
            this.account = atob(atob1);
            this.password = atob(atob2);
        }else{
            this.account = localStorage.getItem('account');
            this.password = localStorage.getItem('password');
        }
        // if(localStorage.getItem('account2')){
        //     this.account2 =  localStorage.getItem('account2');
        //     this.password2 =  localStorage.getItem('password2');
        // }
        this.roleId = localStorage.getItem('roleId');
        this.userId = localStorage.getItem('userId');
        this.node_id = localStorage.getItem('loginId')
        // console.log(localStorage.getItem('menuList'));
        if(!localStorage.getItem('menuList')){
            this.$router.push("/");
        }
        if((localStorage.getItem('equal') && this.roleId != '113') || this.roleId == 133){
            if(this.roleId != 133){
                this.equal = true;
            }
            this.getCountFun()
        }else{
            this.equal = false;
        }
    },
    mounted(){
        if(this.equal){
            this.getYyztFun();
        }
        this.$nextTick(()=>{            
            if(document.getElementById('two-menu')){
                document.getElementById('two-menu').style.height = this.$refs.twoMenu.offsetHeight - 70 + 'px'
            }
        })
        setTimeout(()=>{
            this.user = localStorage.getItem("loginName");
            if(this.roleId == 9 || this.account == 'sjcj' || this.roleId == 138){
                this.isShow = true;
            }else if(this.user != '' && this.user != null){
                if(this.user.indexOf('丰台')>-1){
                    this.isShow1 = true;
                }
            }else{
                this.isShow = false;
            }
        },200)
        if(localStorage.getItem('menuList')){
            this.mainList = JSON.parse(localStorage.getItem('menuList'));//查询菜单列表
            // this.levelOneCurrId = this.mainList[0].id;//选择第一项
            // this.changeMenu(this.levelOneCurrId);
            if(localStorage.getItem('routerId')){   
                let state = false;     
                this.mainList.forEach(val => {
                    if(val.node == this.$route.meta.node){
                        state = true;
                    }
                })
                if(state){
                    this.levelOneCurrId = localStorage.getItem('routerId');//选择第一项
                    let levelTwoCurrId = localStorage.getItem('levelTwoCurrId')
                    this.firstLoadFun(this.levelOneCurrId);
                    if(localStorage.getItem('levelTwoCurrId')){
                        this.firstLoadFun(localStorage.getItem('levelTwoCurrId'));
                    }
                    // let to = this.$route;
                    // let toId = to.meta.id;
                    // let parentId = '';
                    // if(to.meta.node == 'statistical'){
                    //     this.mainList.forEach(ele => {
                    //         if(ele.node == 'statistical'){
                    //             if(ele.children.id == toId){
                    //                 this.enterChildPage = false;
                    //             }else{
                    //                 this.enterChildPage = true;
                    //                 this.mainList.forEach(ele => {
                    //                     if(ele.node == "statistical"){//market页操作
                    //                         ele.children.nodeList.forEach(val=> {
                    //                             if(val.id == toId){
                    //                                 this.parentName = ele.children.nav_title;
                    //                                 this.childrenName = val.text;
                    //                             }
                    //                         })
                    //                     }
                    //                 })
                    //                 this.mainList.forEach(ele => {//market子页操作 - 获得子级名称
                    //                     if(ele.node == "statistical"){
                    //                         ele.children.nodeList.forEach(ele=> {
                    //                         if(ele.children && ele.children.nodeList.length > 0){
                    //                             ele.children.nodeList.forEach(val => {
                    //                                 if(val.id == toId ){
                    //                                     parentId = val.parentId;
                    //                                     if(to.params.name){
                    //                                         this.childrenName = to.params.name;
                    //                                     }else{
                    //                                         this.childrenName = val.text;
                    //                                     }

                    //                                 }
                    //                             })
                    //                         }
                    //                         })
                    //                     }
                    //                 })
                    //                 this.mainList.forEach(ele => {//market子页操作 - 获得上一级名称
                    //                     if(ele.node == "statistical"){
                    //                         ele.children.nodeList.forEach(ele=> {
                    //                             if(ele.id == parentId){
                    //                                 this.parentName = ele.text;
                    //                             }
                    //                         })
                    //                     }
                    //                 })
                    //             }
                    //         }
                    //     })
                    // }else if(to.meta.node == 'retail'){
                    //     // this.enterChildPage = false;
                    //     this.mainList.forEach(ele => {
                    //         if(ele.node == 'retail'){
                    //                 if(ele.children.id == toId){
                    //                     this.enterChildPage = false;
                    //                 }else{
                    //                     this.enterChildPage = true;
                    //                     this.mainList.forEach(ele => {
                    //                         if(ele.node == "retail"){//market页操作
                    //                             ele.children.nodeList.forEach(val=> {
                    //                                 if(val.id == toId){
                    //                                     this.parentName = ele.children.nav_title;
                    //                                     this.childrenName = val.text;
                    //                                 }
                    //                             })
                    //                         }
                    //                     })
                    //                     this.mainList.forEach(ele => {//market子页操作 - 获得子级名称
                    //                         if(ele.node == "retail"){
                    //                             ele.children.nodeList.forEach(ele=> {
                    //                             if(ele.children && ele.children.nodeList.length > 0){
                    //                                 ele.children.nodeList.forEach(val => {
                    //                                     if(val.id == toId ){
                    //                                             parentId = val.parentId;
                    //                                             if(to.params.name){
                    //                                                 this.childrenName = to.params.name;
                    //                                             }else{
                    //                                                 this.childrenName = val.text;
                    //                                             }

                    //                                         }
                    //                                 })
                    //                             }
                    //                             })
                    //                         }
                    //                     })
                    //                     this.mainList.forEach(ele => {//market子页操作 - 获得上一级名称
                    //                         if(ele.node == "retail"){
                    //                             ele.children.nodeList.forEach(ele=> {
                    //                                 if(ele.id == parentId){
                    //                                     this.parentName = ele.text;
                    //                                 }
                    //                             })
                    //                         }
                    //                     })
                    //                 }
                    //         }
                    //     })
                    // }else if(to.meta.node == 'enterpriseCy'){
                    //     // this.enterChildPage = false;
                    //     this.mainList.forEach(ele => {
                    //         if(ele.node == 'enterpriseCy'){
                    //                 if(ele.children.id == toId){
                    //                     this.enterChildPage = false;
                    //                 }else{
                    //                     this.enterChildPage = true;
                    //                     this.mainList.forEach(ele => {
                    //                         if(ele.node == "enterpriseCy"){//market页操作
                    //                             ele.children.nodeList.forEach(val=> {
                    //                                 if(val.id == toId){
                    //                                     this.parentName = ele.children.nav_title;
                    //                                     this.childrenName = val.text;
                    //                                 }
                    //                             })
                    //                         }
                    //                     })
                    //                     this.mainList.forEach(ele => {//market子页操作 - 获得子级名称
                    //                         if(ele.node == "enterpriseCy"){
                    //                             ele.children.nodeList.forEach(ele=> {
                    //                             if(ele.children && ele.children.nodeList.length > 0){
                    //                                 ele.children.nodeList.forEach(val => {
                    //                                     if(val.id == toId ){
                    //                                             parentId = val.parentId;
                    //                                             if(to.params.name){
                    //                                                 this.childrenName = to.params.name;
                    //                                             }else{
                    //                                                 this.childrenName = val.text;
                    //                                             }

                    //                                         }
                    //                                 })
                    //                             }
                    //                             })
                    //                         }
                    //                     })
                    //                     this.mainList.forEach(ele => {//market子页操作 - 获得上一级名称
                    //                         if(ele.node == "enterpriseCy"){
                    //                             ele.children.nodeList.forEach(ele=> {
                    //                                 if(ele.id == parentId){
                    //                                     this.parentName = ele.text;
                    //                                 }
                    //                             })
                    //                         }
                    //                     })
                    //                 }
                    //         }
                    //     })
                    // }else if(to.meta.node == 'role'){
                    //     this.mainList.forEach(ele => {
                    //         if(ele.node == 'role'){
                    //                 if(ele.children.id == toId){
                    //                     this.enterChildPage = false;
                    //                 }else{
                    //                     this.enterChildPage = true;
                    //                     this.mainList.forEach(ele => {
                    //                         if(ele.node == "role"){//market页操作
                    //                             ele.children.nodeList.forEach(val=> {
                    //                                 if(val.id == toId){
                    //                                     this.parentName = ele.children.nav_title;
                    //                                     this.childrenName = val.text;
                    //                                 }
                    //                             })
                    //                         }
                    //                     })
                    //                     this.mainList.forEach(ele => {//market子页操作 - 获得子级名称
                    //                         if(ele.node == "role"){
                    //                             ele.children.nodeList.forEach(ele=> {
                    //                             if(ele.children && ele.children.nodeList.length > 0){
                    //                                 ele.children.nodeList.forEach(val => {
                    //                                     if(val.id == toId ){
                    //                                             parentId = val.parentId;
                    //                                             if(to.params.name){
                    //                                                 this.childrenName = to.params.name;
                    //                                             }else{
                    //                                                 this.childrenName = val.text;
                    //                                             }

                    //                                         }
                    //                                 })
                    //                             }
                    //                             })
                    //                         }
                    //                     })
                    //                     this.mainList.forEach(ele => {//market子页操作 - 获得上一级名称
                    //                         if(ele.node == "role"){
                    //                             ele.children.nodeList.forEach(ele=> {
                    //                                 if(ele.id == parentId){
                    //                                     this.parentName = ele.text;
                    //                                 }
                    //                             })
                    //                         }
                    //                     })
                    //                 }
                    //         }
                    //     })
                    // }else if(to.meta.node == 'retrieval'){
                    //     this.mainList.forEach(ele => {
                    //         if(ele.node == 'retrieval'){
                    //                 if(ele.children.id == toId){
                    //                     this.enterChildPage = false;
                    //                 }else{
                    //                     this.enterChildPage = true;
                    //                     this.mainList.forEach(ele => {
                    //                         if(ele.node == "retrieval"){//market页操作
                    //                             ele.children.nodeList.forEach(val=> {
                    //                                 if(val.id == toId){
                    //                                     this.parentName = ele.children.nav_title;
                    //                                     this.childrenName = val.text;
                    //                                 }
                    //                             })
                    //                         }
                    //                     })
                    //                     this.mainList.forEach(ele => {//market子页操作 - 获得子级名称
                    //                         if(ele.node == "retrieval"){
                    //                             ele.children.nodeList.forEach(ele=> {
                    //                             if(ele.children && ele.children.nodeList.length > 0){
                    //                                 ele.children.nodeList.forEach(val => {
                    //                                     if(val.id == toId ){
                    //                                             parentId = val.parentId;
                    //                                             if(to.params.name){
                    //                                                 this.childrenName = to.params.name;
                    //                                             }else{
                    //                                                 this.childrenName = val.text;
                    //                                             }

                    //                                         }
                    //                                 })
                    //                             }
                    //                             })
                    //                         }
                    //                     })
                    //                     this.mainList.forEach(ele => {//market子页操作 - 获得上一级名称
                    //                         if(ele.node == "retrieval"){
                    //                             ele.children.nodeList.forEach(ele=> {
                    //                                 if(ele.id == parentId){
                    //                                     this.parentName = ele.text;
                    //                                 }
                    //                             })
                    //                         }
                    //                     })
                    //                 }
                    //         }
                    //     })
                    // }else if(to.meta.node == 'district'){
                    //     this.mainList.forEach(ele => {
                    //         if(ele.node == 'district'){
                    //                 if(ele.children.id == toId){
                    //                     this.enterChildPage = false;
                    //                 }else{
                    //                     this.enterChildPage = true;
                    //                     this.mainList.forEach(ele => {
                    //                         if(ele.node == "district"){//market页操作
                    //                             ele.children.nodeList.forEach(val=> {
                    //                                 if(val.id == toId){
                    //                                     this.parentName = ele.children.nav_title;
                    //                                     this.childrenName = val.text;
                    //                                 }
                    //                             })
                    //                         }
                    //                     })
                    //                     this.mainList.forEach(ele => {//market子页操作 - 获得子级名称
                    //                         if(ele.node == "district"){
                    //                             ele.children.nodeList.forEach(ele=> {
                    //                             if(ele.children && ele.children.nodeList.length > 0){
                    //                                 ele.children.nodeList.forEach(val => {
                    //                                     if(val.id == toId ){
                    //                                             parentId = val.parentId;
                    //                                             if(to.params.name){
                    //                                                 this.childrenName = to.params.name;
                    //                                             }else{
                    //                                                 this.childrenName = val.text;
                    //                                             }

                    //                                         }
                    //                                 })
                    //                             }
                    //                             })
                    //                         }
                    //                     })
                    //                     this.mainList.forEach(ele => {//market子页操作 - 获得上一级名称
                    //                         if(ele.node == "district"){
                    //                             ele.children.nodeList.forEach(ele=> {
                    //                                 if(ele.id == parentId){
                    //                                     this.parentName = ele.text;
                    //                                 }
                    //                             })
                    //                         }
                    //                     })
                    //                 }
                    //         }
                    //     })
                    // }else{
                    //     this.mainList.forEach(ele=> {
                    //         if(ele.node == to.meta.node){
                    //             if(ele.children && ele.children.node && ele.children.node != 'district' && ele.children.node != 'statistical' && ele.children.node != 'retail' && ele.children.node != 'role' && ele.children.node != 'retrieval' && ele.children.node != 'enterpriseCy'){
                    //                 if(ele.children.nodeList.length > 0){
                    //                     ele.children.nodeList.forEach(ele=>{
                    //                         if(ele.id == toId){
                    //                             this.enterChildPage = false;
                    //                             this.childrenName = ele.text;
                    //                             parentId = ele.parentId;
                    //                             this.mainList.forEach(ele=>{
                    //                                 if(ele.children && ele.children.id == parentId){
                    //                                     this.parentName = ele.children.nav_title
                    //                                 }
                    //                             })
                    //                         }
                    //                     })
                    //                 }
                    //             }else{
                    //                 if(ele.children && ele.children.nodeList.length > 0){
                    //                     ele.children.nodeList.forEach(ele =>{//二级
                    //                         if(ele.children && ele.children.nodeList.length > 0){
                    //                             ele.children.nodeList.forEach(ele =>{//三级
                    //                                 if(ele.id == toId){
                    //                                     this.enterChildPage = false;
                    //                                 }else{
                    //                                     if(ele.children && ele.children.nodeList.length > 0){
                    //                                         ele.children.nodeList.forEach(ele => {
                    //                                             if(ele.id == toId){
                    //                                                 this.enterChildPage = true;
                    //                                                 parentId = ele.parentId;
                    //                                                 this.childrenName = ele.text;
                    //                                                 this.mainList.forEach(ele => {
                    //                                                     if(ele.children && ele.children.nodeList.length > 0){
                    //                                                         ele.children.nodeList.forEach(ele => {
                    //                                                             if(ele.children && ele.children.nodeList.length > 0){
                    //                                                                 ele.children.nodeList.forEach(ele => {
                    //                                                                     if(ele.id == parentId){
                    //                                                                         this.parentName = ele.text;
                    //                                                                     }
                    //                                                                 })

                    //                                                             }
                    //                                                         })
                    //                                                     }
                    //                                                 })
                    //                                             }
                    //                                         })
                    //                                     }
                    //                                 }
                    //                             })
                    //                         }
                    //                     })
                    //                 }
                    //             }
                    //         }
                    //     })

                    // }
                    // getDefaultProductTypes()
                    // .then(res => {
                    //     localStorage.setItem('queryNameData',JSON.stringify(res))
                    // })
                    // .catch(res => {
                    //     this.$message.error("出错啦!");
                    // })
                }else{
                    if(localStorage.getItem('routerId')){        
                        localStorage.removeItem('routerId');
                    }
                    if(localStorage.getItem('levelTwoCurrId')){        
                        localStorage.removeItem('levelTwoCurrId');
                    }
                    if(this.mainList.length > 0){
                        this.levelOneCurrId = this.mainList[0].id;//选择第一项
                        this.changeMenu(this.levelOneCurrId);
                        localStorage.setItem('routerId', this.levelOneCurrId)
                    }
                }
            }else{
                if(this.mainList.length > 0){
                    this.levelOneCurrId = this.mainList[0].id;//选择第一项
                    this.changeMenu(this.levelOneCurrId);
                    localStorage.setItem('routerId', this.levelOneCurrId)
                }
            }
            // // 查询品种列表
            // getDefaultProductTypes()
            //     .then(res => {
            //     localStorage.setItem('queryNameData',JSON.stringify(res))
            //     })
            //     .catch(res => {
            //         this.$message.error("出错啦!");
            //     })
        }else{
            this.$router.push("/")
        }
        if(localStorage.getItem('remember')){
            this.remember = localStorage.getItem('remember')
            if(localStorage.getItem('remember') == 'true'){
                let localAccount = localStorage.getItem('account');
                let localPassword = localStorage.getItem('password');
                if(localAccount.indexOf('cryptographic+') != -1){
                    let atob1 = localAccount.substr(14);
                    let atob2 = localPassword.substr(14);
                    this.account = atob(atob1);
                    this.password = atob(atob2);
                }else{
                    this.account = localStorage.getItem('account');
                    this.password = localStorage.getItem('password');
                }
            }
        }
        // if(localStorage.getItem('routeMsg1')){
        //     localStorage.removeItem('routeMsg1')
        // }
        // if(localStorage.getItem('routeMsg2')){
        //     localStorage.removeItem('routeMsg2')
        // }
        if(localStorage.getItem('searchMsg1')){
            localStorage.removeItem('searchMsg1')
        }
        if(localStorage.getItem('searchMsg2')){
            localStorage.removeItem('searchMsg2')
        }
        if(localStorage.getItem('searchMsg3')){
            localStorage.removeItem('searchMsg3')
        }
        // if(localStorage.getItem('bigAreaId')){
        //     localStorage.removeItem('bigAreaId')
        // }
        if(localStorage.getItem('activeName')){
            localStorage.removeItem('activeName')
        }
        if(localStorage.getItem('labelPosition')){
            localStorage.removeItem('labelPosition')
        }
    },
    updated() {
        if(this.$route.meta.node == 'noticeQy'){
            if(this.$route.name == 'ViewNoticeQy' || this.$route.name == 'ViewLegislationQy' || this.$route.name == 'ViewTrainDataQy' || this.$route.name == 'NewsQyList'){
                if(localStorage.getItem('noticeQy')){
                    localStorage.removeItem('noticeQy');
                    this.getCountFun()
                }
            }
        }else if(this.$route.meta.node == 'inspection'){
            window.scrollTo(0,0);
            if(localStorage.getItem('monitor') == 'true'){
                if(localStorage.getItem('routeMsg')){
                    localStorage.removeItem('routeMsg')
                }
                if(localStorage.getItem('routeMsg1')){
                    localStorage.removeItem('routeMsg1')
                }
                if(localStorage.getItem('routeMsg2')){
                    localStorage.removeItem('routeMsg2')
                }
                if(localStorage.getItem('routeMsg3')){
                    localStorage.removeItem('routeMsg3')
                }
                if(localStorage.getItem('keepRecord')){        
                    localStorage.removeItem('keepRecord');
                }
                if(localStorage.getItem('retail')){        
                    localStorage.removeItem('retail');
                }
                if(localStorage.getItem('searchMsg')){
                    localStorage.removeItem('searchMsg')
                }
                if(localStorage.getItem('searchMsg1')){
                    localStorage.removeItem('searchMsg1')
                }
                if(localStorage.getItem('routeMsg2')){
                    localStorage.removeItem('routeMsg2')
                }
                if(localStorage.getItem('searchMsg2')){
                    localStorage.removeItem('searchMsg2')
                }
                if(localStorage.getItem('searchMsg3')){
                    localStorage.removeItem('searchMsg3')
                }
                if(localStorage.getItem('bigAreaId')){
                    localStorage.removeItem('bigAreaId')
                }
                if(localStorage.getItem('activeName')){
                    localStorage.removeItem('activeName')
                }
                if(localStorage.getItem('labelPosition')){
                    localStorage.removeItem('labelPosition')
                }
                if(localStorage.getItem('monitor')){
                    localStorage.removeItem('monitor')
                }
                if(localStorage.getItem('step')){        
                    localStorage.removeItem('step');
                }
                this.levelOneCurrId = localStorage.getItem('routerId');
                this.levelTwoCurrId = localStorage.getItem('levelTwoCurrId');
                this.firstLoadFun(this.levelOneCurrId);
                if(localStorage.getItem('levelTwoCurrId')){
                    this.firstLoadFun(localStorage.getItem('levelTwoCurrId'));
                }
                // this.monitorFun()   
            }
        }else if(localStorage.getItem('step') == 'true'){
            // 新手指引跳转菜单判断
            // localStorage.removeItem('step')
            // if(localStorage.getItem('routeMsg')){
            //     localStorage.removeItem('routeMsg')
            // }
            // if(localStorage.getItem('routeMsg1')){
            //     localStorage.removeItem('routeMsg1')
            // }
            // if(localStorage.getItem('routeMsg2')){
            //     localStorage.removeItem('routeMsg2')
            // }
            // if(localStorage.getItem('routeMsg3')){
            //     localStorage.removeItem('routeMsg3')
            // }
            // if(localStorage.getItem('keepRecord')){        
            //     localStorage.removeItem('keepRecord');
            // }
            // if(localStorage.getItem('retail')){        
            //     localStorage.removeItem('retail');
            // }
            // if(localStorage.getItem('searchMsg')){
            //     localStorage.removeItem('searchMsg')
            // }
            // if(localStorage.getItem('searchMsg1')){
            //     localStorage.removeItem('searchMsg1')
            // }
            // if(localStorage.getItem('routeMsg2')){
            //     localStorage.removeItem('routeMsg2')
            // }
            // if(localStorage.getItem('searchMsg2')){
            //     localStorage.removeItem('searchMsg2')
            // }
            // if(localStorage.getItem('searchMsg3')){
            //     localStorage.removeItem('searchMsg3')
            // }
            // if(localStorage.getItem('bigAreaId')){
            //     localStorage.removeItem('bigAreaId')
            // }
            // if(localStorage.getItem('activeName')){
            //     localStorage.removeItem('activeName')
            // }
            // if(localStorage.getItem('labelPosition')){
            //     localStorage.removeItem('labelPosition')
            // }
            // if(localStorage.getItem('monitor')){
            //     localStorage.removeItem('monitor')
            // }
            // // if(localStorage.getItem('equal')){        
            // //     localStorage.removeItem('equal');
            // // }
            // this.levelOneCurrId = localStorage.getItem('routerId');
            // this.levelTwoCurrId = localStorage.getItem('levelTwoCurrId');
            // this.firstLoadFun(this.levelOneCurrId);
            // if(localStorage.getItem('levelTwoCurrId')){
            //     this.firstLoadFun(localStorage.getItem('levelTwoCurrId'));
            // }
        }else if(this.$route.meta.node == 'settings'){
            if(localStorage.getItem('settings') == 1){
                localStorage.removeItem('settings');
                localStorage.setItem('routerId', 98);
                localStorage.setItem('levelTwoCurrId', 690);
                this.monitorFun();
            }
            if(this.equal){
                this.getYyztFun();
            }
        }
    },
    watch:{
        // $route(to,from){
        //     let toId = to.meta.id;
        //     let parentId = '';
        //     this.fromPrevPageMsg = from.meta;
        //     this.toPrevPageMsg = to.meta;
        //     if(to.meta.node == 'statistical'){
        //         // this.enterChildPage = false;
        //         this.mainList.forEach(ele => {
        //            if(ele.node == 'statistical'){
        //                 if(ele.children.id == toId){
        //                     this.enterChildPage = false;
        //                 }else{
        //                     this.enterChildPage = true;
        //                     this.mainList.forEach(ele => {
        //                         if(ele.node == "statistical"){//market页操作
        //                             ele.children.nodeList.forEach(val=> {
        //                                 if(val.id == toId){
        //                                     this.parentName = ele.children.nav_title;
        //                                     this.childrenName = val.describe;
        //                                 }
        //                             })
        //                         }
        //                     })
        //                     this.mainList.forEach(ele => {//market子页操作 - 获得子级名称
        //                         if(ele.node == "statistical"){
        //                             ele.children.nodeList.forEach(ele=> {
        //                                if(ele.children && ele.children.nodeList.length > 0){
        //                                    ele.children.nodeList.forEach(val => {
        //                                        if(val.id == toId ){
        //                                             parentId = val.parentId;
        //                                             if(to.params.name){
        //                                                 this.childrenName = to.params.name;
        //                                             }else{
        //                                                 this.childrenName = val.describe;
        //                                             }

        //                                         }
        //                                    })
        //                                }
        //                             })
        //                         }
        //                     })
        //                     this.mainList.forEach(ele => {//market子页操作 - 获得上一级名称
        //                         if(ele.node == "statistical"){
        //                             ele.children.nodeList.forEach(ele=> {
        //                                 if(ele.id == parentId){
        //                                     this.parentName = ele.describe;
        //                                 }
        //                             })
        //                         }
        //                     })
        //                 }
        //            }
        //        })
        //     }else if(to.meta.node == 'retail'){
        //         // this.enterChildPage = false;
        //         this.mainList.forEach(ele => {
        //            if(ele.node == 'retail'){
        //                 if(ele.children.id == toId){
        //                     this.enterChildPage = false;
        //                 }else{
        //                     this.enterChildPage = true;
        //                     this.mainList.forEach(ele => {
        //                         if(ele.node == "retail"){//market页操作
        //                             ele.children.nodeList.forEach(val=> {
        //                                 if(val.id == toId){
        //                                     this.parentName = ele.children.nav_title;
        //                                     this.childrenName = val.describe;
        //                                 }
        //                             })
        //                         }
        //                     })
        //                     this.mainList.forEach(ele => {//market子页操作 - 获得子级名称
        //                         if(ele.node == "retail"){
        //                             ele.children.nodeList.forEach(ele=> {
        //                                if(ele.children && ele.children.nodeList.length > 0){
        //                                    ele.children.nodeList.forEach(val => {
        //                                        if(val.id == toId ){
        //                                             parentId = val.parentId;
        //                                             if(to.params.name){
        //                                                 this.childrenName = to.params.name;
        //                                             }else{
        //                                                 this.childrenName = val.describe;
        //                                             }

        //                                         }
        //                                    })
        //                                }
        //                             })
        //                         }
        //                     })
        //                     this.mainList.forEach(ele => {//market子页操作 - 获得上一级名称
        //                         if(ele.node == "retail"){
        //                             ele.children.nodeList.forEach(ele=> {
        //                                 if(ele.id == parentId){
        //                                     this.parentName = ele.describe;
        //                                 }
        //                             })
        //                         }
        //                     })
        //                 }
        //            }
        //        })
        //     }else if(to.meta.node == 'role'){
        //         // this.enterChildPage = false;
        //         this.mainList.forEach(ele => {
        //            if(ele.node == 'role'){
        //                 if(ele.children.id == toId){
        //                     this.enterChildPage = false;
        //                 }else{
        //                     this.enterChildPage = true;
        //                     this.mainList.forEach(ele => {
        //                         if(ele.node == "role"){//market页操作
        //                             ele.children.nodeList.forEach(val=> {
        //                                 if(val.id == toId){
        //                                     this.parentName = ele.children.nav_title;
        //                                     this.childrenName = val.describe;
        //                                 }
        //                             })
        //                         }
        //                     })
        //                     this.mainList.forEach(ele => {//market子页操作 - 获得子级名称
        //                         if(ele.node == "role"){
        //                             ele.children.nodeList.forEach(ele=> {
        //                                if(ele.children && ele.children.nodeList.length > 0){
        //                                    ele.children.nodeList.forEach(val => {
        //                                        if(val.id == toId ){
        //                                             parentId = val.parentId;
        //                                             if(to.params.name){
        //                                                 this.childrenName = to.params.name;
        //                                             }else{
        //                                                 this.childrenName = val.describe;
        //                                             }

        //                                         }
        //                                    })
        //                                }
        //                             })
        //                         }
        //                     })
        //                     this.mainList.forEach(ele => {//market子页操作 - 获得上一级名称
        //                         if(ele.node == "role"){
        //                             ele.children.nodeList.forEach(ele=> {
        //                                 if(ele.id == parentId){
        //                                     this.parentName = ele.describe;
        //                                 }
        //                             })
        //                         }
        //                     })
        //                 }
        //            }
        //        })
        //     }else if(to.meta.node == 'retrieval'){
        //         // this.enterChildPage = false;
        //         this.mainList.forEach(ele => {
        //            if(ele.node == 'retrieval'){
        //                 if(ele.children.id == toId){
        //                     this.enterChildPage = false;
        //                 }else{
        //                     this.enterChildPage = true;
        //                     this.mainList.forEach(ele => {
        //                         if(ele.node == "retrieval"){//market页操作
        //                             ele.children.nodeList.forEach(val=> {
        //                                 if(val.id == toId){
        //                                     this.parentName = ele.children.nav_title;
        //                                     this.childrenName = val.describe;
        //                                 }
        //                             })
        //                         }
        //                     })
        //                     this.mainList.forEach(ele => {//market子页操作 - 获得子级名称
        //                         if(ele.node == "retrieval"){
        //                             ele.children.nodeList.forEach(ele=> {
        //                                if(ele.children && ele.children.nodeList.length > 0){
        //                                    ele.children.nodeList.forEach(val => {
        //                                        if(val.id == toId ){
        //                                             parentId = val.parentId;
        //                                             if(to.params.name){
        //                                                 this.childrenName = to.params.name;
        //                                             }else{
        //                                                 this.childrenName = val.describe;
        //                                             }

        //                                         }
        //                                    })
        //                                }
        //                             })
        //                         }
        //                     })
        //                     this.mainList.forEach(ele => {//market子页操作 - 获得上一级名称
        //                         if(ele.node == "retrieval"){
        //                             ele.children.nodeList.forEach(ele=> {
        //                                 if(ele.id == parentId){
        //                                     this.parentName = ele.describe;
        //                                 }
        //                             })
        //                         }
        //                     })
        //                 }
        //            }
        //        })
        //     }else if(to.meta.node == 'quotation'){
        //         // this.enterChildPage = false;
        //         this.mainList.forEach(ele => {
        //            if(ele.node == 'quotation'){
        //                 if(ele.children.id == toId){
        //                     this.enterChildPage = false;
        //                 }else{
        //                     this.enterChildPage = true;
        //                     this.mainList.forEach(ele => {
        //                         if(ele.node == "quotation"){//market页操作
        //                             ele.children.nodeList.forEach(val=> {
        //                                 if(val.id == toId){
        //                                     this.parentName = ele.children.nav_title;
        //                                     this.childrenName = val.describe;
        //                                 }
        //                             })
        //                         }
        //                     })
        //                     this.mainList.forEach(ele => {//market子页操作 - 获得子级名称
        //                         if(ele.node == "quotation"){
        //                             ele.children.nodeList.forEach(ele=> {
        //                                if(ele.children && ele.children.nodeList.length > 0){
        //                                    ele.children.nodeList.forEach(val => {
        //                                        if(val.id == toId ){
        //                                             parentId = val.parentId;
        //                                             if(to.params.name){
        //                                                 this.childrenName = to.params.name;
        //                                             }else{
        //                                                 this.childrenName = val.describe;
        //                                             }

        //                                         }
        //                                    })
        //                                }
        //                             })
        //                         }
        //                     })
        //                     this.mainList.forEach(ele => {//market子页操作 - 获得上一级名称
        //                         if(ele.node == "quotation"){
        //                             ele.children.nodeList.forEach(ele=> {
        //                                 if(ele.id == parentId){
        //                                     this.parentName = ele.describe;
        //                                 }
        //                             })
        //                         }
        //                     })
        //                 }
        //            }
        //        })
        //     }else if(to.meta.node == 'district'){
        //         this.mainList.forEach(ele => {
        //            if(ele.node == 'district'){
        //                 if(ele.children.id == toId){
        //                     this.enterChildPage = false;
        //                 }else{
        //                     this.enterChildPage = true;
        //                     this.mainList.forEach(ele => {
        //                         if(ele.node == "district"){//market页操作
        //                             ele.children.nodeList.forEach(val=> {
        //                                 if(val.id == toId){
        //                                     this.parentName = ele.children.nav_title;
        //                                     this.childrenName = val.describe;
        //                                 }
        //                             })
        //                         }
        //                     })
        //                     this.mainList.forEach(ele => {//market子页操作 - 获得子级名称
        //                         if(ele.node == "district"){
        //                             ele.children.nodeList.forEach(ele=> {
        //                                if(ele.children && ele.children.nodeList.length > 0){
        //                                    ele.children.nodeList.forEach(val => {
        //                                        if(val.id == toId ){
        //                                             parentId = val.parentId;
        //                                             if(to.params.name){
        //                                                 this.childrenName = to.params.name;
        //                                             }else{
        //                                                 this.childrenName = val.describe;
        //                                             }

        //                                         }
        //                                    })
        //                                }
        //                             })
        //                         }
        //                     })
        //                     this.mainList.forEach(ele => {//market子页操作 - 获得上一级名称
        //                         if(ele.node == "district"){
        //                             ele.children.nodeList.forEach(ele=> {
        //                                 if(ele.id == parentId){
        //                                     this.parentName = ele.describe;
        //                                 }
        //                             })
        //                         }
        //                     })
        //                 }
        //            }
        //        })
        //     }else if(to.meta.node == 'DataEnterprise'){
        //         this.mainList.forEach(ele => {
        //            if(ele.node == 'DataEnterprise'){
        //                 if(ele.children.id == toId){
        //                     this.enterChildPage = false;
        //                 }else{
        //                     this.enterChildPage = true;
        //                     this.mainList.forEach(ele => {
        //                         if(ele.node == "DataEnterprise"){//market页操作
        //                             ele.children.nodeList.forEach(val=> {
        //                                 if(val.id == toId){
        //                                     this.parentName = ele.children.nav_title;
        //                                     this.childrenName = val.describe;
        //                                 }
        //                             })
        //                         }
        //                     })
        //                     this.mainList.forEach(ele => {//market子页操作 - 获得子级名称
        //                         if(ele.node == "DataEnterprise"){
        //                             ele.children.nodeList.forEach(ele=> {
        //                                if(ele.children && ele.children.nodeList.length > 0){
        //                                    ele.children.nodeList.forEach(val => {
        //                                        if(val.id == toId ){
        //                                             parentId = val.parentId;
        //                                             if(to.params.name){
        //                                                 this.childrenName = to.params.name;
        //                                             }else{
        //                                                 this.childrenName = val.describe;
        //                                             }

        //                                         }
        //                                    })
        //                                }
        //                             })
        //                         }
        //                     })
        //                     this.mainList.forEach(ele => {//market子页操作 - 获得上一级名称
        //                         if(ele.node == "DataEnterprise"){
        //                             ele.children.nodeList.forEach(ele=> {
        //                                 if(ele.id == parentId){
        //                                     this.parentName = ele.describe;
        //                                 }
        //                             })
        //                         }
        //                     })
        //                 }
        //            }
        //        })
        //     }else{
        //         this.mainList.forEach(ele=> {
        //             if(ele.node == to.meta.node){
        //                 if(ele.children && ele.children.node && ele.children.node != 'district' && ele.children.node != 'statistical' && ele.children.node != 'retail' && ele.children.node != 'role' && ele.children.node != 'retrieval'){
        //                     if(ele.children.nodeList.length > 0){
        //                         ele.children.nodeList.forEach(ele=>{
        //                             if(ele.id == toId){
        //                                 this.enterChildPage = false;
        //                                 this.childrenName = ele.describe;
        //                                 parentId = ele.parentId;

        //                                 this.mainList.forEach(ele=>{
        //                                     if(ele.children && ele.children.id == parentId){
        //                                         this.parentName = ele.children.nav_title
        //                                     }
        //                                 })
        //                             }
        //                         })
        //                     }

        //                 }else{
        //                     if(ele.children && ele.children.nodeList.length > 0){
        //                         ele.children.nodeList.forEach(ele =>{//二级
        //                             if(ele.children && ele.children.nodeList.length > 0){
        //                                 ele.children.nodeList.forEach(ele =>{//三级
        //                                     if(ele.id == toId){
        //                                         this.enterChildPage = false;
        //                                     }else{
        //                                         if(ele.children && ele.children.nodeList.length > 0){
        //                                             ele.children.nodeList.forEach(ele => {
        //                                                 if(ele.id == toId){
        //                                                     this.enterChildPage = true;
        //                                                     parentId = ele.parentId;
        //                                                     this.childrenName = ele.describe;

        //                                                     this.mainList.forEach(ele => {
        //                                                         if(ele.children && ele.children.nodeList.length > 0){
        //                                                             ele.children.nodeList.forEach(ele => {
        //                                                                 if(ele.children && ele.children.nodeList.length > 0){
        //                                                                     ele.children.nodeList.forEach(ele => {
        //                                                                         if(ele.id == parentId){
        //                                                                             this.parentName = ele.describe;
        //                                                                         }
        //                                                                     })

        //                                                                 }
        //                                                             })
        //                                                         }
        //                                                     })
        //                                                 }
        //                                             })
        //                                         }
        //                                     }
        //                                 })
        //                             }
        //                         })
        //                     }


        //                 }
        //             }
        //         })

        //     }
        // }
    },
    methods:{
        getYyztFun(){
            let str = 'node_id=' + this.node_id;
            GetNodeJyzt(str)
                .then(res => {
                    this.yyzt = res.data.jyzt == null ? '' : res.data.jyzt.jyzt;
                    if(res.data.jyzt != null && res.data.jyzt.jyzt_time){
                        this.form.dataTime = res.data.jyzt.jyzt_time.split('~');
                        this.form.startTime = this.form.dataTime[0];
                        this.form.endTime = this.form.dataTime[1];
                    }else{
                        this.form.dataTime = [];
                        this.form.startTime = '';
                        this.form.endTime = '';
                    }
                })
                .catch(res => {
                    console.log(res)
                })
        },
        handleClicks(){

        },
        // 新手指引
        stepFun(){
            this.$router.push({name: 'EnterpriseStep'})
        },
        encode64(input) {  
            var keyStr = "ABCDEFGHIJKLMNOP" + "QRSTUVWXYZabcdef" + "ghijklmnopqrstuv" + "wxyz0123456789+/" + "=";  
            var output = "";  
            var chr1, chr2, chr3 = "";  
            var enc1, enc2, enc3, enc4 = "";  
            var i = 0;  
            do {  
                chr1 = input.charCodeAt(i++);  
                chr2 = input.charCodeAt(i++);  
                chr3 = input.charCodeAt(i++);  
                enc1 = chr1 >> 2;  
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);  
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);  
                enc4 = chr3 & 63;  
                if (isNaN(chr2)) {  
                    enc3 = enc4 = 64;  
                } else if (isNaN(chr3)) {  
                    enc4 = 64;  
                }  
                output = output + keyStr.charAt(enc1) + keyStr.charAt(enc2)  
                    + keyStr.charAt(enc3) + keyStr.charAt(enc4);  
                chr1 = chr2 = chr3 = "";  
                enc1 = enc2 = enc3 = enc4 = "";  
            } while (i < input.length);  
    
            return output;  
        },
        // 超管 PAAS跳转
        jumpPageFun(ele){
            let data = {};
            localStorage.clear();
            sessionStorage.clear();
            let str1 = this.account,
                str2 = this.password;
            if(ele == 1){
                // PAAS
                // data = {
                //     username: this.account + 'p',
                //     password: this.password,
                // }
                // localStorage.setItem('account',this.account + 'p');
                let jm_str1 = this.encode64(str1 + 'p');
                let jm_str2 = this.encode64(str2);
                data = {
                    username: 'cryptographic+' + jm_str1,
                    password: 'cryptographic+' + jm_str2,
                }
                let boat1 = btoa(str1 + 'p');
                localStorage.setItem('account', 'cryptographic+' + boat1);
                localStorage.setItem('username', 'cryptographic+' + boat1);
            }else if(ele == 2){
                // 超管
                // data = {
                //     username: this.account.substr(0, this.account.length - 1),
                //     password: this.password,
                // }
                // localStorage.setItem('account', this.account.substr(0, this.account.length - 1));
                let jm_str1 = this.encode64(str1.substr(0, str1.length - 1));
                let jm_str2 = this.encode64(str2);
                data = {
                    username: 'cryptographic+' + jm_str1,
                    password: 'cryptographic+' + jm_str2,
                }
                let boat1 = btoa(str1.substr(0, str1.length - 1));
                localStorage.setItem('account', 'cryptographic+' + boat1);
                localStorage.setItem('username', 'cryptographic+' + boat1);
            }
            login(data).then((res)=>{
                console.info(res)
                // localStorage.setItem("user", res);
                // console.log(res)
                if(res.data.booth_list.length != 0){
                    let name = res.data.booth_list[0].name,
                        node_id = res.data.booth_list[0].node_id,
                        scShopId = res.data.booth_list[0].SHOP_BOOTH_ID,
                        roleId = res.data.role_list[0].ROLEID;
                    localStorage.setItem('loginName',name ? name : '');
                    localStorage.setItem('loginId',node_id);
                    localStorage.setItem('scShopId',scShopId);
                    localStorage.setItem('userType',res.data.booth_list[0].usertype);
                    localStorage.setItem('nodeidlocal',res.data.booth_list[0].node_id);
                    // sessionStorage.setItem('userName',this.account)
                    // this.setCookie('userName',this.account)
                    if(roleId == 40){
                        localStorage.setItem('booth_List',JSON.stringify(res.data.userInfo.booth_List));
                        localStorage.setItem('parent_node_id', res.data.booth_list[0].PARENT_NODE_ID);
                        localStorage.setItem('name', res.data.booth_list[0].name);
                    }
                }
                if(res.data.userInfo.booth_List){
                    localStorage.setItem('ssdw', res.data.userInfo.booth_List[0].SSDW);
                }
                if(res.data.data_role){
                    let data_role = res.data.data_role;
                    localStorage.setItem('jgjg',data_role.jgjg);
                    localStorage.setItem('jgjgid',data_role.jgjgid);
                }
                if(res.result){
                    let isRegion = res.data.role_list[0].region,
                        roleId = res.data.role_list[0].ROLEID;
                    localStorage.setItem('isRegion',isRegion);
                    localStorage.setExpire("token", roleId, 1000*60*60*24);
                    localStorage.setItem('roleId',roleId);
                    // 配餐企业、单位食堂、学校食堂餐饮企业信息，根据roleId判断
                    // if(roleId != 105 && roleId != 104 && roleId != 103 && roleId != 102){
                    //     localStorage.setItem('unequal', true);
                    // }
                    if(roleId == 105 || roleId == 104 || roleId == 103 || roleId == 102 || roleId == 106 || roleId == 115 || roleId == 113 || roleId == 126 || roleId == 139 || roleId == 136 || roleId == 137){
                        localStorage.setItem('equal', true);
                    }
                    let boat2 = btoa(this.password.replace(/\s*/g,""));
                    localStorage.setItem('password', 'cryptographic+' + boat2);
                    if(this.check){
                    //   if(this.account.indexOf('_ft')>-1 && this.account.split('_')[0] == 'swj'){
                    //     localStorage.setItem('menuList',JSON.stringify(obj1));
                    //   }else if(this.account.indexOf('_ft')>-1 && this.account.split('_')[0] != 'swj'){
                    //     //  localStorage.setItem('menuList',JSON.stringify(obj2));
                    //     localStorage.setItem('menuList',JSON.stringify(res.data.menu_list));
                    //   }else{
                        localStorage.setItem('menuList',JSON.stringify(res.data.menu_list));
                    //   }
                        localStorage.setItem('checked',JSON.stringify(true));
                        localStorage.setItem('userId',res.data.userId);
                        this.userId = res.data.userId;
                    }else{
                    //   if(this.account.indexOf('_ft')>-1 && this.account.split('_')[0] == 'swj'){
                    //     localStorage.setItem('menuList',JSON.stringify(obj1));
                    //   }else if(this.account.indexOf('_ft')>-1 && this.account.split('_')[0] != 'swj'){
                    //     //  localStorage.setItem('menuList',JSON.stringify(obj2));
                    //     localStorage.setItem('menuList',JSON.stringify(res.data.menu_list));
                    //   }else{
                        localStorage.setItem('menuList',JSON.stringify(res.data.menu_list));
                    //   }
                        
                        localStorage.setItem('userId',res.data.userId);
                        this.userId = res.data.userId;
                    }
                    this.$router.push({name:'home'})
                    this.$router.go(0);
                }else{
                    clocalStorage.clear();                    
                }                
            }).catch((res)=>{
                console.log(res)
                this.$message.error('账号或密码输入不正确!')
                localStorage.clear();
                sessionStorage.clear();
                this.$router.push({path:'/'})
            })
            
        },
        getCountFun(){
            let obj = {};
            if(this.roleId == 133){
                obj = {
                    user_id: this.userId,
                    send_state: 2,
                }
            }else{
                obj = {
                    node_id: this.node_id
                }
            }
            GetUnreadMessageCount(obj)
                .then(res => {
                    this.dataList1 = res.data.map.tzgg_list;
                    this.dataList2 = res.data.map.pxcl_list;
                    this.dataList3 = res.data.map.wdxx_list;
                    this.badge = res.data.map['总数'] ? res.data.map['总数'] : 0;
                    this.badge1 = res.data.map['通知公告'] ? res.data.map['通知公告'] : 0;
                    // this.badge2 = res.data.map['法律法规'] ? res.data.map['法律法规'] : 0;
                    this.badge3 = res.data.map['培训材料'] ? res.data.map['培训材料'] : 0;
                    this.badge4 = res.data.map['我的消息'] ? res.data.map['我的消息'] : 0;
                })
                .catch(res => {
                    console.log(res)
                })
        },
        jumpFun(ele){
            if(ele == 2){
                window.open('http://shop.zhdtech.com/UpdateRecords/index.html');
            }else{
                // window.open('http://shop.zhdtech.com/login/operation');
                window.open('http://shop.zhdtech.com/login/operation?role_id=' + this.roleId);
            }
        },
        // 通知公告跳转
        noticeQyFun(ele){
            localStorage.setItem('routerId', 707)
            // if(ele == 1){
            //     localStorage.setItem('levelTwoCurrId', 707)
            // }else if(ele == 2){
            //     localStorage.setItem('levelTwoCurrId', 709)
            // }else if(ele == 3){
            //     localStorage.setItem('levelTwoCurrId', 777)
            // }else if(ele == 4){
            //     localStorage.setItem('levelTwoCurrId', 795)
            // }
            if(this.activeNames == 'first'){
                if(ele == 0){
                    localStorage.setItem('levelTwoCurrId', 707)
                }else if(ele == 1){
                    localStorage.setItem('levelTwoCurrId', 709)
                }else{
                    localStorage.setItem('levelTwoCurrId', 707)
                }
            }else if(this.activeNames == 'second'){
                localStorage.setItem('levelTwoCurrId', 777)
            }else if(this.activeNames == 'third'){
                localStorage.setItem('levelTwoCurrId', 795)
            }
            if(localStorage.getItem('routerId')){   
                let state = false;     
                this.mainList.forEach(val => {
                    if(val.node == this.$route.meta.node){
                        state = true;
                    }
                })
                if(state){
                    this.levelOneCurrId = localStorage.getItem('routerId');//选择第一项
                    let levelTwoCurrId = localStorage.getItem('levelTwoCurrId')
                    this.firstLoadFun(this.levelOneCurrId);
                    if(localStorage.getItem('levelTwoCurrId')){
                        this.firstLoadFun(localStorage.getItem('levelTwoCurrId'));
                    }
                    if(this.activeNames == 'first'){
                        if(ele == 0){
                            this.$router.push({name: 'NoticeQyList'})
                        }else if(ele == 1){
                            this.$router.push({name: 'LegislationQyList'})
                        }else{
                            this.$router.push({name: 'NoticeQyList'})
                        }
                    }else if(this.activeNames == 'second'){
                        this.$router.push({name: 'TrainDataQyList'})
                    }else if(this.activeNames == 'third'){
                        this.$router.push({name: 'NewsQyList'})
                    }
                    // if(ele == 1){
                    //     this.$router.push({name: 'NoticeQyList'})
                    // }else if(ele == 2){
                    //     this.$router.push({name: 'LegislationQyList'})
                    // }else if(ele == 3){
                    //     this.$router.push({name: 'TrainDataQyList'})
                    // }else if(ele == 4){
                    //     this.$router.push({name: 'NewsQyList'})
                    // }
                }else{
                    if(localStorage.getItem('routerId')){        
                        localStorage.removeItem('routerId');
                    }
                    if(localStorage.getItem('levelTwoCurrId')){        
                        localStorage.removeItem('levelTwoCurrId');
                    }
                    if(this.mainList.length > 0){
                        this.levelOneCurrId = this.mainList[0].id;//选择第一项
                        this.changeMenu(this.levelOneCurrId);
                        localStorage.setItem('routerId', this.levelOneCurrId)
                    }
                }
            }
        },
        // cpscjd统计跳转, pcqycs 核酸跳转
        monitorFun(){
            if(localStorage.getItem('routerId')){   
                let state = false;     
                this.mainList.forEach(val => {
                    if(val.node == this.$route.meta.node){
                        state = true;
                    }
                })
                if(state){
                    this.levelOneCurrId = localStorage.getItem('routerId');//选择第一项
                    let levelTwoCurrId = localStorage.getItem('levelTwoCurrId')
                    this.firstLoadFun(this.levelOneCurrId);
                    if(localStorage.getItem('levelTwoCurrId')){
                        this.firstLoadFun(localStorage.getItem('levelTwoCurrId'));
                    }
                }
            }
        },
        firstLoadFun(tabTd){
            console.log(tabTd)
            this.levelThreeMenu = []
            let types = 2;
            if(localStorage.getItem('levelTwoCurrId') && localStorage.getItem('routerId')){
                if(localStorage.getItem('levelTwoCurrId') && localStorage.getItem('routerId')){
                    types = 2
                }else{
                    types = 1
                }
            }
            // this.mainList.forEach(ele => {
            //     if(ele.children){
            //         if(ele.children.url){
            //             types = 1
            //         }else{
            //             types = 2
            //         }
            //     }
            // })
            if(types == 1){
                // 没有二级菜单
                this.isShowLevelTwo = false;
                this.isHasDistance = false;
                this.levelOneCurrId = tabTd;
                this.mainList.forEach(ele => {
                    if(ele.id == tabTd){
                        this.levelThreeMenu.push({
                            id:ele.id,
                            title:ele.text
                        })
                        this.$router.push({path:`/home/${ele.node}/${ele.children.url}`});
                    }
                })
            }else{
                this.mainList.forEach(ele => {//属于一级ID
                    if(ele.level == 1 && ele.id == tabTd && ele.children.node){
                        this.levelOneCurrId = tabTd;
                        this.isShowLevelTwo = false;
                        this.isHasDistance = false;
                        this.mainList.forEach(ele => {
                            if(ele.id == tabTd){
                                this.levelThreeMenu.push({
                                    id:ele.id,
                                    title:ele.children.nav_title
                                })
                            }
                        })
                    }
                    if(ele.level == 1 && ele.id == tabTd && !ele.children.node){
                        this.isShowLevelTwo = true;
                        this.isHasDistance = true;
                        this.levelOneCurrId = tabTd;
                        this.levelTwoMenu = ele.children.nodeList;//二级菜单列表
                        this.typeArr = [];
                        ele.children.nodeList.forEach(ele =>{
                            if(ele.type && !this.typeArr.includes(ele.type)){
                                this.typeArr.push(ele.type)
                            }
                        })
                        this.levelTwoTitle = ele.children.nav_title;//二级菜单标题
                        this.levelTwoCurrId = ele.children.nodeList[0].id;//二级菜单选中项
                        ele.children.nodeList[0].children.nodeList.forEach(ele => {
                            this.levelThreeMenu.push({
                                id:ele.id,
                                title:ele.text
                            })
                        })
                    }
                })
                this.mainList.forEach(ele => {//属于二级ID
                    if(ele.children){
                        ele.children.nodeList.forEach((ele)=>{
                            if(ele.level == 2 && ele.id == tabTd){
                                this.levelTwoCurrId = tabTd;
                                ele.children.nodeList.forEach(ele => {
                                    this.levelThreeMenu.push({
                                        id:ele.id,
                                        title:ele.text
                                    })
                                })
                                if(ele.describe == "自定义图表"){
                                    window.open('https://signin.aliyun.com/zhdtech.onaliyun.com/login.htm');      
                                    return
                                }
                                if(ele.children.nodeList && ele.children.nodeList.length >1){
                                    this.levelThreeCurrId = ele.children.nodeList[0].id
                                }
                            }
                        })
                    }
                })
            }
        },
        changeMenu(tabTd){//菜单切换
            window.scrollTo(0,0);
            if(localStorage.getItem('routeMsg')){
                localStorage.removeItem('routeMsg')
            }
            if(localStorage.getItem('routeMsg1')){
                localStorage.removeItem('routeMsg1')
            }
            if(localStorage.getItem('routeMsg2')){
                localStorage.removeItem('routeMsg2')
            }
            if(localStorage.getItem('routeMsg3')){
                localStorage.removeItem('routeMsg3')
            }
            if(localStorage.getItem('keepRecord')){        
                localStorage.removeItem('keepRecord');
            }
            if(localStorage.getItem('retail')){        
                localStorage.removeItem('retail');
            }
            if(localStorage.getItem('searchMsg')){
                localStorage.removeItem('searchMsg')
            }
            if(localStorage.getItem('searchMsg1')){
                localStorage.removeItem('searchMsg1')
            }
            if(localStorage.getItem('routeMsg2')){
                localStorage.removeItem('routeMsg2')
            }
            if(localStorage.getItem('searchMsg2')){
                localStorage.removeItem('searchMsg2')
            }
            if(localStorage.getItem('searchMsg3')){
                localStorage.removeItem('searchMsg3')
            }
            if(localStorage.getItem('bigAreaId')){
                localStorage.removeItem('bigAreaId')
            }
            if(localStorage.getItem('activeName')){
                localStorage.removeItem('activeName')
            }
            if(localStorage.getItem('labelPosition')){
                localStorage.removeItem('labelPosition')
            }
            if(localStorage.getItem('monitor')){
                localStorage.removeItem('monitor')
            }
            // if(localStorage.getItem('equal')){        
            //     localStorage.removeItem('equal');
            // }
            // 761 2级菜单地址id
            if(tabTd != 761){
                if(localStorage.getItem('levelTwoCurrId')){        
                    localStorage.removeItem('levelTwoCurrId');
                }
                localStorage.setItem('levelTwoCurrId', tabTd)
            }
            let types = 1;
            this.mainList.forEach(ele => {
                if(ele.children){
                    if(ele.children.nodeList.length > 0){
                        types = 2
                        // this.mainList.forEach(ele => {//属于一级ID
                            // if(ele.children){
                                if(ele.level == 1 && ele.id == tabTd && ele.children.node){
                                    this.levelOneCurrId = tabTd;
                                    this.isShowLevelTwo = false;
                                    this.isHasDistance = false;
                                    this.mainList.forEach(ele => {
                                        if(ele.id == tabTd){
                                            this.levelThreeMenu.push({
                                                id:ele.id,
                                                title:ele.children.nav_title
                                            })
                                            localStorage.setItem('routerId', ele.id)
                                            this.$router.push({path:`/home/${ele.node}/${ele.children.url}`});
                                        }
                                    })
                                }else if(ele.level == 1 && ele.id == tabTd && !ele.children.node){
                                    this.isShowLevelTwo = true;
                                    this.isHasDistance = true;
                                    this.levelOneCurrId = tabTd;
                                    this.levelTwoMenu = ele.children.nodeList;//二级菜单列表
                                    this.typeArr = [];
                                    ele.children.nodeList.forEach(ele =>{
                                        if(ele.type && !this.typeArr.includes(ele.type)){
                                            this.typeArr.push(ele.type)
                                        }
                                    })
                                    this.levelTwoTitle = ele.children.nav_title;//二级菜单标题
                                    this.levelTwoCurrId = ele.children.nodeList[0].id;//二级菜单选中项
                                    ele.children.nodeList[0].children.nodeList.forEach(ele => {
                                        this.levelThreeMenu.push({
                                            id:ele.id,
                                            title:ele.text
                                        })
                                    })
                                    localStorage.setItem('routerId', ele.id)
                                    this.$router.push({
                                        path:`/home/${ele.node}/${ele.children.nodeList[0].children.nodeList[0].url}`
                                    });

                                }else{
                                    ele.children.nodeList.forEach((ele)=>{
                                        if(ele.level == 2 && ele.id == tabTd){
                                            if(ele.describe == "自定义图表"){
                                                window.open('https://signin.aliyun.com/zhdtech.onaliyun.com/login.htm');      
                                                return
                                            }
                                            if(ele.describe == "可视化数据大屏"){
                                                window.open('http://m.zhdtech.com/traceScreen/');      
                                                return
                                            }
                                            this.levelTwoCurrId = tabTd;
                                            ele.children.nodeList.forEach(ele => {
                                                this.levelThreeMenu.push({
                                                    id:ele.id,
                                                    title:ele.text
                                                })
                                            })
                                            if(ele.children.nodeList && ele.children.nodeList.length >1){
                                                this.levelThreeCurrId = ele.children.nodeList[0].id
                                            }
                                            this.$router.push({
                                                path:`/home/${ele.node}/${ele.children.nodeList[0].url}`
                                            });
                                        }
                                    })
                                }
                    }else{
                        types = 1
                        // 没有二级菜单
                        this.isShowLevelTwo = false;
                        this.isHasDistance = false;
                        this.levelOneCurrId = tabTd;
                        // this.mainList.forEach(ele => {
                            if(ele.id == tabTd){
                                this.levelThreeMenu.push({
                                    id:ele.id,
                                    title:ele.text
                                })
                                // localStorage.setItem('routerId', ele.id)
                                this.$router.push({path:`/home/${ele.node}/${ele.children.url}`});
                            }
                        // })
                        
                    }
                }
            })
        },
        selectMenu(id){//选择菜单
            let that = this
            // 开启延时器，200ms的间隔用来区分单击和双击，解决双击时执行两次单击事件
            clearTimeout(that.time);
            that.click_time = setTimeout(() => {
                //单击事件
                if(window._axiosPromiseArr.length > 0){
                    window._axiosPromiseArr.forEach((ele,index) => {
                        ele.cancel() // 路由跳转之前，清空（终止）上一个页面正在请求的内容
                        // 清空请求的参数 清空请求的参数
                        delete window._axiosPromiseArr[index]
                        // Toast.clear();
                    })
                    // Object.assign(this.$data, this.$options.data());
                }
                this.levelThreeMenu = [];
                this.enterChildPage = false;
                this.changeMenu(id)
            },200);
        },
        dbclick() {
            clearTimeout(this.click_time);
        // 双击事件 不写不执行，禁用
        },
        backPrev(){//三级菜单返回上页
            if(this.$route.meta.node == 'statistical'){
                let name = '';
                this.mainList.forEach(ele => {
                    if(ele.node == 'statistical'){
                        name = ele.children.nav_title
                    }
                })
                if(this.parentName == name){
                    this.enterChildPage = false;
                    this.$router.push({name:'StatisticsMsg'})
                }else{
                    this.enterChildPage = true;
                    this.$router.push({path:this.fromPrevPageMsg.url})
                }
            }else if(this.$route.meta.node == 'retail'){
                let name = '';
                this.mainList.forEach(ele => {
                    if(ele.node == 'retail'){
                        name = ele.children.nav_title
                    }
                })

                if(this.parentName == name){
                    this.enterChildPage = false;
                    this.$router.push({name:'RetailList'})
                }else{
                    this.enterChildPage = true;
                    this.$router.push({path:this.fromPrevPageMsg.url})
                }
            }else if(this.$route.meta.node == 'quotation'){
                let name = '';
                this.mainList.forEach(ele => {
                    if(ele.node == 'quotation'){
                        name = ele.children.nav_title
                    }
                })

                if(this.parentName == name){
                    this.enterChildPage = false;
                    this.$router.push({name:'QuotationList'})
                }else{
                    this.enterChildPage = true;
                    this.$router.push({path:this.fromPrevPageMsg.url})
                }
            }else if(this.$route.meta.node == 'role'){
                let name = '';
                this.mainList.forEach(ele => {
                    if(ele.node == 'role'){
                        name = ele.children.nav_title
                    }
                })

                if(this.parentName == name){
                    this.enterChildPage = false;
                    this.$router.push({name:'RoleManagement'})
                }else{
                    this.enterChildPage = true;
                    this.$router.push({path:this.fromPrevPageMsg.url})
                }
            }else if(this.$route.meta.node == 'retrieval'){
                let name = '';
                this.mainList.forEach(ele => {
                    if(ele.node == 'retrieval'){
                        name = ele.children.nav_title
                    }
                })

                if(this.parentName == name){
                    this.enterChildPage = false;
                    this.$router.push({name:'LedgerMsg'})
                }else{
                    this.enterChildPage = true;
                    this.$router.push({path:this.fromPrevPageMsg.url})
                }
            }else if(this.$route.meta.node == 'district'){
                let name = '';
                this.mainList.forEach(ele => {
                    if(ele.node == 'district'){
                        name = ele.children.nav_title
                    }
                })
                if(this.parentName == name){
                    this.enterChildPage = false;
                    this.$router.push({path:'market'})
                }else{
                    this.enterChildPage = true;
                    this.$router.push({path:this.fromPrevPageMsg.url})
                }
            }else if(this.$route.meta.node == 'DataEnterprise'){
                let name = '';
                this.mainList.forEach(ele => {
                    if(ele.node == 'DataEnterprise'){
                        name = ele.children.nav_title
                    }
                })
                if(this.parentName == name){
                    this.enterChildPage = false;
                    this.$router.push({path:'DataReportList'})
                }else{
                    this.enterChildPage = true;
                    this.$router.push({path:this.fromPrevPageMsg.url})
                }
            }else{
                this.enterChildPage = false;
                let parentId = '',id_1_level = '',id_2_level = '';
                this.mainList.forEach(ele=> {
                    if(ele.children && ele.children.nodeList.length>0){
                        ele.children.nodeList.forEach(ele =>{
                            if(ele.children && ele.children.nodeList.length>0){
                                ele.children.nodeList.forEach(ele =>{
                                    if(ele.id == this.fromPrevPageMsg.id){
                                        id_1_level = ele.level;
                                    }
                                    if(ele.id == this.toPrevPageMsg.id){
                                        id_1_level = ele.level;
                                    }
                                    if(ele.children && ele.children.nodeList.length>0){
                                        ele.children.nodeList.forEach(ele => {
                                            if(ele.id == this.fromPrevPageMsg.id){
                                                id_1_level = ele.level;
                                            }
                                            if(ele.id == this.toPrevPageMsg.id){
                                                id_2_level = ele.level;
                                                parentId = ele.parentId;
                                            }
                                        })
                                    }
                                })
                            }
                        })
                    }
                })
                if(id_1_level == 4 && id_2_level == 4){
                    this.mainList.forEach(ele=> {
                        if(ele.children && ele.children.nodeList.length>0){
                            ele.children.nodeList.forEach(ele =>{
                                if(ele.children && ele.children.nodeList.length>0){
                                    ele.children.nodeList.forEach(ele =>{
                                        if(ele.id == parentId){
                                            this.$router.push({path:ele.url})
                                        }
                                    })
                                }
                            })
                        }
                    })
                }else{
                    this.$router.push({path:this.fromPrevPageMsg.url})
                }
            }
        },
        turnPage(item){//三级菜单切换
            this.mainList.forEach(ele=> {
                if(ele.children && ele.children.nodeList.length>0){
                    ele.children.nodeList.forEach(ele =>{
                        if(ele.children && ele.children.nodeList.length>0){
                            ele.children.nodeList.forEach(ele =>{
                                if(ele.id == item.id){
                                    this.$router.push({path:ele.url})
                                    this.levelThreeCurrId = ele.id;
                                }
                            })
                        }
                    })
                }
            })
        },
        userClick(){//用户点击
            this.isExit = !this.isExit;
            this.isPaas = !this.isPaas;
            this.isCg = !this.isCg;
        },
        backLogin(){//退出
            localStorage.clear();
            sessionStorage.clear();
            if(this.remember == 'true'){
                let boat1 = btoa(this.account.replace(/\s*/g,""));
                let boat2 = btoa(this.password.replace(/\s*/g,""));
                localStorage.setItem('account', 'cryptographic+' + boat1);
                localStorage.setItem('password', 'cryptographic+' + boat2);
                localStorage.setItem('remember',this.remember);
            }
            Loginout()
                .then(res => {
                    this.$router.push({path:'/'})
                })
                .catch(res => {
                    // console.log(res)
                })
        },
    }

}
</script>
<style lang='less' scoped>
    @import '../../assets/css/common.css';
    @fs14 : 14px;
    @fs16 : 16px;
    @fsc333 : #333;
    @fsc000 : #000;
    .container{
        position: relative;
        overflow: hidden;
        min-width: 1200px;
        .node-tips{
            position: fixed;
            bottom: 0;
            z-index: 5001;
            width: 100%;
            height: 40px;
            line-height: 40px;
            text-align: center;
            color: #fff;
            background: #CC0000;
            span{
                display: inline-block;
                margin-right: 10px;
            }
        }
        .main{
            margin-left: 100px;
            padding: 70px 10px 10px;
            box-sizing: border-box;
            overflow: hidden;
        }
        .left-distance200{
            margin-left: 250px;
        }
        .left-distance100{
            margin-left: 50px;
        }
        .left-distance180{
            margin-left: 180px;
        }
        .level-one-menu{
            position: fixed;
            left: 0;
            top: 0;
            width: 50px;
            height: 100%;
            background: #33363f;
            color: #fff;
            z-index: 5000;
            overflow: hidden;
            transition: all .5s ease-in;
            .text{
                width: 0;
                overflow: hidden;
            }
            &:hover{
                width: 110px;
                // width:135px;
                .text{
                    width: 200px;
                }
                transition-delay: 0;
                transition-property: width,overflow;
                transition-duration: ease-in;
            } /***/
            .logo{
                display: block;
                margin: 10px auto;
                width: 50px;
                height: 50px;
                img{
                    display: block;
                    width: 100%;
                    height: 100%;
                }
            }
            .menu-list{
                margin-top: 10px;
                font-size: 12px;
                .menu-item{
                    padding-left: 10px;
                    display: -webkit-box;
                    height: 54px;
                    line-height: 54px;
                    cursor: pointer;
                    &:hover,&.active{
                        background: #fff;
                        color: #000;
                    }
                }
            }
            .icon{
                display: inline-block;
                font-size: 0;
                width: 24px;
                height: 24px;
                vertical-align: text-top;
            }
        }
        .level-one-menu1{
            &:hover{
                // width: 100px;
                width:150px;
            }
        }
        .level-one-menu2{
            &:hover{
                width:120px;
            }
        }
        .icon-traceabiltyInfo{
            background: url('../../assets/images/assets.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-retrieval{
            background: url('../../assets/images/retrieval.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-enterprise{
            background: url('../../assets/images/enterprise.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-tzFarming{
            background: url('../../assets/images/tzFarming.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-standingBook{
            background: url('../../assets/images/standingBook.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-production{
            background: url('../../assets/images/production.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-tzSlaughter{
            background: url('../../assets/images/tzSlaughter.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-management{
            background: url('../../assets/images/management.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-user{
            background: url('../../assets/images/management.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-goods{
            background: url('../../assets/images/goods.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-farmworksy{
            background: url('../../assets/images/farmworksy.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-settings{
            background: url('../../assets/images/settings.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-differentSz{
            background: url('../../assets/images/settings.svg') no-repeat center center;
            background-size: 100% 100%;
        }

        .icon-farmwork{
            background: url('../../assets/images/farmwork.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-statistical{
            background: url('../../assets/images/statistical.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-district{
            background: url('../../assets/images/district.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-role{
            background: url('../../assets/images/role.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-fun{
            background: url('../../assets/images/fun.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-analyze{
            background: url('../../assets/images/analyze.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-traceEquipment{
            background: url('../../assets/images/traceEquipment.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-assets{
            background: url('../../assets/images/assets.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-retail{
            background: url('../../assets/images/retail.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-DataEnterprise{
            background: url('../../assets/images/traceEquipment.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-FtReport{
           background: url('../../assets/images/analyze.svg') no-repeat center center;
           background-size: 100% 100%;
        }
        .icon-FtReport{
           background: url('../../assets/images/analyze.svg') no-repeat center center;
           background-size: 100% 100%;
        }
        .icon-DataReport{
            background: url('../../assets/images/collect.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-repair{
            background: url('../../assets/images/repair.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-control{
            background: url('../../assets/images/control.svg') no-repeat center center;
            background-size: 100% 100%;
        }

        .icon-analysis{
            background: url('../../assets/images/analysis.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-collect{
            background: url('../../assets/images/collect.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-warning{
            background: url('../../assets/images/warning.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-nodeManage{
            background: url('../../assets/images/nodeManage.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-supervise{
            background: url('../../assets/images/supervise.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-monitor{
            background: url('../../assets/images/statistical.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-cropManagement{
            background: url('../../assets/images/management.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-farmworkcommodity{
            background: url('../../assets/images/goods.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-farmworkreview{
            background: url('../../assets/images/management.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-quotation{
            background: url('../../assets/images/retail.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-dataPort{
            background: url('../../assets/images/dataPort.svg') no-repeat center center;
            background-size: 85% 90%;
        }
        .icon-compare{
            background: url('../../assets/images/management.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-platform{
            background: url('../../assets/images/retail.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-establishment{
            background: url('../../assets/images/enterprise.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-survey{
            background: url('../../assets/images/supervise.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-report{
            background: url('../../assets/images/supervise.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-approach{
            background: url('../../assets/images/statistical.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-standingBookCq{
            background: url('../../assets/images/standingBook.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-reportGwzx{
            background: url('../../assets/images/control.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-reportCs{
            background: url('../../assets/images/control.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-reportFt{
            background: url('../../assets/images/collect.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-enterpriseFt{
            background: url('../../assets/images/enterprise.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-enterpriseCy{
            background: url('../../assets/images/enterprise.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-manageCy{
            background: url('../../assets/images/management.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-superviseJc{
            background: url('../../assets/images/enterprise.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-notice{
            background: url('../../assets/images/notice.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-monitorCy{
            background: url('../../assets/images/assets.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-noticeQy{
            background: url('../../assets/images/notice.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-trainQy{
            background: url('../../assets/images/retrieval.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-administration{
            background: url('../../assets/images/standingBook.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-keepRecord{
            background: url('../../assets/images/nodeManage.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-inspection{
            background: url('../../assets/images/control.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-reportShop{
            background: url('../../assets/images/control.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-enterpriseShop{
            background: url('../../assets/images/enterprise.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-reportCy{
            background: url('../../assets/images/collect.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-nodeAccount{
            background: url('../../assets/images/management.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-nuclein{
            background: url('../../assets/images/nuclein.svg') no-repeat center center;
            background-size: 90% 90%;
        }
        .icon-reportLs{
            background: url('../../assets/images/collect.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-enterpriseLs{
            background: url('../../assets/images/enterprise.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-reportQt{
            background: url('../../assets/images/collect.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-enterpriseQt{
            background: url('../../assets/images/enterprise.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-monitorQuery{
            background: url('../../assets/images/retrieval.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-monitorReport{
            background: url('../../assets/images/collect.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-tracing{
            background: url('../../assets/images/management.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-gateManage{
            background: url('../../assets/images/management.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-infoArticle{
            background: url('../../assets/images/infoArticle.svg') no-repeat center center;
            background-size: 80% 80%;
        }
        .icon-salesData{
            background: url('../../assets/images/retrieval.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-dataReportMerge{
            background: url('../../assets/images/collect.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-necessaries{
            background: url('../../assets/images/management.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-dataScreen{
            background: url('../../assets/images/statistical.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-supervisionQy{
            background: url('../../assets/images/control.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-systemFile{
            background: url('../../assets/images/u8505.png') no-repeat center center;
            background-size: 90% 90%;
        }
        .icon-feedback{
            background: url('../../assets/images/u8505.png') no-repeat center center;
            background-size: 90% 90%;
        }
        .icon-taskAnalysis{
            background: url('../../assets/images/statistical.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-cadreBb{
            background: url('../../assets/images/enterprise.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-noticeBb{
            background: url('../../assets/images/notice.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-programmeBb{
            background: url('../../assets/images/assets.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-subjectBb{
            background: url('../../assets/images/management.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-systemBb{
            background: url('../../assets/images/u8505.png') no-repeat center center;
            background-size: 90% 90%;
        }
        .icon-ledgerScQy{
            background: url('../../assets/images/standingBook.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-ledgerScJg{
            background: url('../../assets/images/standingBook.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-dailyInspect{
            background: url('../../assets/images/collect.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .icon-weighing{
            background: url('../../assets/images/collect.svg') no-repeat center center;
            background-size: 100% 100%;
        }
        .level-two-menu{
            position: fixed;
            left: 50px;
            top: 0;
            width: 200px;
            height: 100%;
            color:#333;
            font-size: @fs14;
            background: #fff;
            border-right: 1px solid #ddd;
            box-sizing: border-box;
            z-index: 101;
            #two-menu{
                overflow-y: auto;
            }
            .title{
                display: block;
                width: 100%;
                height: 59px;
                line-height: 59px;
                font-size: 16px;
                text-align: center;
                font-weight: 900;
                text-align: center;
                box-sizing: border-box;
            }
            .border{
                border-bottom:1px solid #ddd;
            }
            .menu-list{
                .type-name{
                    display:block;
                    padding-top:10px;
                    margin-left: 10px;
                    height:38px;
                    line-height:38px;
                    font-size:12px;
                    color:#aaa;
                }
                .type-list{
                    margin-bottom: 5px;
                }
                .menu-item{
                    font-size: 13px;
                    padding-left: 10px;
                    height: 38px;
                    line-height: 38px;
                    cursor: pointer;
                    overflow: hidden;
                }
                .active{
                    background: #ddd;
                }
            }
        }
        .level-three-menu{
            position: fixed;
            left: 0;
            top: 0;
            right: 0;
            height: 60px;
            background: #fff;
            color: #333;
            font-size: @fs14;
            z-index: 101;
            .nav-bar{
                padding: 0 35px;
                display: flex;
                justify-content: flex-end;
                align-items: center;
                min-width: 1000px;
                height: 60px;
                border-bottom: 1px solid #e4e4e4;
                background: #fff;
                box-sizing: border-box;
                .title{
                    display: inline-block;
                    margin-right: 20px;
                    color: #333;
                    font-size: 14px;
                    height: 60px;
                    border-bottom: 1px solid;
                    border-color: #e4e4e4;
                    box-sizing: border-box;
                    cursor: pointer;
                }
                .current{
                    border-color: #409EFF;
                    color: #409EFF;
                }
                .prev-title{
                    color: #409EFF;
                }
            }
            .right-haddle{
                float: right;
                display: flex;
                align-items: center;
                .step{
                    padding: 2px 5px;
                    color: #fff;
                    font-size: 12px;
                    background: #2C6FFE;
                    border-radius: 10px;
                    cursor: pointer;
                }
                .icon{
                    display: inline-block;
                    position: relative;
                    *zoom: 1;
                    top: 2px;
                    width: 16px;
                    height: 16px;
                    vertical-align: baseline;
                    cursor: pointer;
                }
                .icon-1{
                    margin-left: 15px;
                    background: url('../../assets/images/u4161.png') no-repeat center center;
                    background-size: 100% 100%;
                }
                .icon-2{
                    margin-left: 15px;
                    background: url('../../assets/images/u4155.png') no-repeat;
                    background-size: 100% 100%;
                }
                .icon-3{
                    background: url('../../assets/images/u4159.png') no-repeat;
                    background-size: 100% 100%;
                }
                .icon-group{
                    float: left;
                }
                .user{
                    float: right;
                    margin-left: 15px;
                    position: relative;
                    font-size: @fs14;
                    cursor: pointer;
                }
                .exit-btns{
                    position: absolute;
                    z-index: 670;
                    top: 45px;
                    right: 0;
                }
                .exit{
                    display: block;
                    padding: 7px 5px;
                    width: 50px;
                    height: 20px;
                    line-height: 20px;
                    text-align: center;
                    background: #f2f2f2;
                    font-style: normal;
                    z-index: 10;
                    border: 1px solid #ddd;
                    &:hover{
                        background: #409EFF;
                        color: #fff;
                        border-color: #409EFF;
                    }
                }
            }
        }
        .tips-badge{
            font-size: 12px;
            line-height: 30px;
            cursor: pointer;
            color: red;
        }
    }
    .list{
        width: 300px;
        .item{
            .title{
                display: flex;
                align-items: center;
                font-size: 14px;
                font-weight: bolder;
                span{
                    margin: 0 5px;
                }
            }
            .text{
                margin: 5px 0;
                font-size: 14px;
            }
            .message{
                display: flex;
                justify-content: space-between;
                font-size: 12px;
                color: #999;
            }
        }
        .btns{
            text-align: center;
            font-size: 12px;
            color: #999;
        }
    }
</style>
<style lang="less">
    .home-tabs{
        width: 320px !important;
        .el-tabs__content{
            height: 200px !important;
            overflow: hidden;
        }
        .el-tabs__content:hover{
            overflow: auto;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/home/home.vue